import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { CircleIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { cva } from "class-variance-authority"

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-3", className)}
      {...props}
    />
  )
}

const indicatorIconVariants = cva("absolute top-1/2 left-1/2 size-3 -translate-x-1/2 -translate-y-1/2", {
  variants: {
    variant: {
      default: "fill-primary",
      "theme": "fill-theme-links"
    }
  }
})

const itemVariants = cva("focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", {
  variants: {
    variant: {
      default: "border-input text-primary",
      "theme": "border-theme text-theme-0"
    }
  }
})

function RadioGroupItem({
  className,
  variant = "theme",
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & { variant?: "default" | "theme" }) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(itemVariants({ variant, className }))}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon className={cn(indicatorIconVariants({ variant }), "stroke-none")} />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
